import ServiceCRUD from '../../../services/ServiceCRUD';
import { apiCase as http } from '../../../http';
class Protocol extends ServiceCRUD {
  constructor() {
    super('protocols');
  }

  async createProtocolByRecordType(recordTypeId, data) {
    return http.post(`/protocols/create/${recordTypeId}`, data);
  }

  async getProtocolsByRecordType(recordTypeId, params, headers = {}) {
    return http.get(`/protocols/${recordTypeId}`, { params, headers });
  }

  async getProtocolsByRecordTypeKanban(recordTypeId, params) {
    return http.get(`/protocols/kamban/${recordTypeId}`, { params });
  }

  async getProtocolsAllRecordType(params) {
    return http.get(`/protocols/all`, { params });
  }
  async getProtocols(params) {
    return http.get(`/protocols`, { params });
  }

  async getProtocolOverallSLAInfoByRecordType(recordTypeId, params) {
    return http.get(`/protocols/sla-overall/${recordTypeId}`, { params });
  }

  async getByIdAndRecordType(protocolId, recordTypeId) {
    return http.get(`/protocols/${protocolId}/${recordTypeId}`);
  }

  updateByRecordType(protocolId, recordTypeId, data) {
    return http.put(`/protocols/${protocolId}/${recordTypeId}`, data);
  }

  async updateNoStrictByRecordType(protocolId, recordTypeId, data) {
    return http.put(`/protocols/nostrict/${protocolId}/${recordTypeId}`, data);
  }

  async removeAttachment(protocolId, attachmentId) {
    return http.delete(`/protocols/${protocolId}/attachments/${attachmentId}`);
  }

  async updateMultProtocols(data) {
    return http.put(`/protocols/updateMults`, data);
  }

  async addAttachments(protocolId, formData) {
    return http.post(`/protocols/${protocolId}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  async getDashboardManagerInfo(queryParams = {}, recordTypeId) {
    return http.get(`/protocols/dashboard/manager/${recordTypeId}`, {
      params: queryParams
    });
  }

  async getDashboardAgentInfo(queryParams = {}, recordTypeId) {
    return http.get(`/protocols/dashboard/agent/${recordTypeId}`, {
      params: queryParams
    });
  }

  updateParentProtocol(data) {
    return http.put(`/protocols/parent`, data);
  }

  forwardComments(protocolId, commentIds, formData) {
    return http.post(`/protocols/v3/${protocolId}/comments/forward`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  changeRecordType(data) {
    return http.post(`/protocols/v3/changeRecordType`, data);
  }

  getCustomFieldsValues(protocolId, recordTypeId, entity = 'PROTOCOL') {
    return http.get(
      `/protocols/v3/getMappedCustomFields/${protocolId}/${recordTypeId}/${entity}`
    );
  }

  getUsersByRecordTypeId(recordTypeId, active = null) {
    const url = `/users/by-record-type/${recordTypeId}${active !== null ? `?active=${active}` : ''}`;
    return http.get(url);
  }

  getNewProtocolHistory(protocolId) {
    return http.get(`/protocol-history/${protocolId}`);
  }
  /**
   * Marks comments of multiple protocols as read for a specific user.
   * @param {object} data - The data containing protocol IDs and user ID.
   * @param {string[]} data.protocols - An array of protocol IDs whose comments should be marked as read.
   * @param {string} data.userId - The ID of the user for whom the comments are being marked as read.
   * @returns {Promise<any>} A promise that resolves with the API response.
   */
  markProtocolsCommentsAsRead(data) {
    return http.post('/protocols/v3/read-all-protocols-comments', data);
  }

  /**
   * Marks comments of multiple protocols as unread for a specific user.
   * @param {object} data - The data containing protocol IDs and user ID.
   * @param {string[]} data.protocols - An array of protocol IDs whose comments should be marked as unread.
   * @param {string} data.userId - The ID of the user for whom the comments are being marked as unread.
   * @returns {Promise<any>} A promise that resolves with the API response.
   */
  markProtocolsCommentsAsUnread(data) {
    return http.post('/protocols/v3/unread-all-protocols-comments', data);
  }

  markCommentAsRead(data) {
    const { protocolId } = data;
    return http.post(`/protocols/v3/${protocolId}/comments/read-comment`, data);
  }

  markCommentAsUnread(data) {
    const { protocolId, commentId } = data;
    return http.delete(
      `/protocols/v3/${protocolId}/comments/${commentId}/unread-comment`
    );
  }

  updateNotificationAgent(protocolId, data) {
    return http.put(
      `/protocols/v3/${protocolId}/changeNotificationAgent`,
      data
    );
  }
}

export default new Protocol();
